export default defineAppConfig({
  ui: {
    badge: {
      slots: {
        base: 'justify-center',
      },
    },
    card: {
      slots: {
        header: 'px-3 py-2 sm:px-3 sm:py-2',
        body: 'px-3 py-2 sm:px-3 sm:py-2',
        footer: 'px-3 py-2 sm:px-3 sm:py-2',
      },
    },
  },
});
